import {
  GET_LIVE_STREAMS,
  GET_STREAM,
  STREAM_NOT_LIVE,
  GET_MODERATORS,
  MAKE_MODERATOR,
  UPDATE_MODERATOR,
  REMOVE_MODERATOR,
  MODERATOR_ERROR,
  SEND_MESSAGE,
  DELETE_CHAT_MESSAGE,
  SEND_MOD_MESSAGE,
  DELETE_MODCHAT_MESSAGE,
  GET_TIMED_OUT_USERS,
  GET_BANNED_USERS,
  TIMEOUT_USER,
  UNTIMEOUT_USER,
  STREAM_ERROR,
  GET_SUPPORTERS,
  ADD_SUPPORTER,
  DELETE_SUPPORTER,
  SUPPORTER_ERROR,
  BAN_USER,
  UNBAN_USER,
} from "../actions/types";

const initialState = {
  live: false,
  isError: false,
  chatMessages: [],
  modChatMessages: [],
  livestreams: [],
  moderators: [],
  timed_out_users: [],
  banned_users: [],
  supporters: [],
  stream_loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_LIVE_STREAMS:
      return {
        ...state,
        livestreams: payload,
        stream_loading: false,
      };
    case GET_STREAM:
      return {
        ...state,
        isError: true,
        stream_loading: false,
      };
    case STREAM_NOT_LIVE:
      return {
        ...state,
        isError: false,
        stream_loading: true,
      };
    case GET_MODERATORS:
      return {
        ...state,
        moderators: payload,
        stream_loading: false,
      };
    case GET_SUPPORTERS:
      return {
        ...state,
        supporters: payload,
        stream_loading: false,
      };
    case MAKE_MODERATOR:
      return {
        ...state,
        moderators: [payload, ...state.moderators],
        stream_loading: false,
      };
    case SEND_MESSAGE:
      return {
        ...state,
        chatMessages: [...state.chatMessages, payload],
      };
    case SEND_MOD_MESSAGE:
      return {
        ...state,
        modChatMessages: [...state.modChatMessages, payload],
      };
    case DELETE_CHAT_MESSAGE:
      return {
        ...state,
        chatMessages: state.chatMessages.filter((X) => X.messageid !== payload),
      };
    case DELETE_MODCHAT_MESSAGE:
      return {
        ...state,
        modChatMessages: state.modChatMessages.filter(
          (X) => X.messageid !== payload,
        ),
      };
    case GET_TIMED_OUT_USERS:
      return {
        ...state,
        timed_out_users: payload,
      };
    case GET_BANNED_USERS:
      return {
        ...state,
        banned_users: payload,
      };
    case TIMEOUT_USER:
      return {
        ...state,
        timed_out_users: [payload, ...state.timed_out_users],
      };
    case BAN_USER:
      return {
        ...state,
        banned_users: [payload, ...state.banned_users],
      };
    case ADD_SUPPORTER:
      return {
        ...state,
        supporters: [payload, ...state.supporters],
      };
    case UPDATE_MODERATOR:
      return {
        ...state,
        moderators: [
          payload,
          ...state.moderators.filter(
            (user) => user.channelid !== payload.channelid,
          ),
        ],
      };
    case REMOVE_MODERATOR:
      return {
        ...state,
        moderators: state.moderators.filter(
          (user) => user.channelid !== payload,
        ),
      };
    case UNTIMEOUT_USER:
      return {
        ...state,
        timed_out_users: state.timed_out_users.filter(
          (user) => user.channelid !== payload,
        ),
      };
    case UNBAN_USER:
      return {
        ...state,
        banned_users: state.banned_users.filter(
          (user) => user.channelid !== payload,
        ),
      };
    case DELETE_SUPPORTER:
      return {
        ...state,
        supporters: state.supporters.filter((user) => user._id !== payload),
      };
    case STREAM_ERROR:
    case MODERATOR_ERROR:
    case SUPPORTER_ERROR:
      return {
        ...state,
        error: payload,
        stream_loading: false,
      };
    default:
      return state;
  }
}
